import { render, staticRenderFns } from "./Wechat.vue?vue&type=template&id=46733a3e&scoped=true&"
import script from "./Wechat.vue?vue&type=script&lang=js&"
export * from "./Wechat.vue?vue&type=script&lang=js&"
import style0 from "./Wechat.vue?vue&type=style&index=0&id=46733a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46733a3e",
  null
  
)

export default component.exports